import * as React from "react";
const SvgFiBrandsOracle = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-brands-oracle_svg__a)">
      <path
        fill="#151A2D"
        d="M10.384 12.468h1.583l-.836-1.35-1.537 2.439h-.7l1.87-2.926a.445.445 0 0 1 .727-.005l1.875 2.93h-.699l-.329-.544h-1.602l-.349-.543m7.263.542V10.47h-.594v2.792c0 .078.032.153.088.208a.3.3 0 0 0 .216.09h2.7l.352-.545h-2.766m-9.818-.458a1.044 1.044 0 0 0 0-2.088H5.231v3.087h.593v-2.54h1.967a.5.5 0 0 1 0 1H6.118l1.772 1.54h.861l-1.19-.998zm-6.245 1h1.794a1.544 1.544 0 0 0 0-3.086H1.583a1.544 1.544 0 0 0-.08 3.086zm1.754-.544H1.623a.998.998 0 0 1 0-1.997h1.714a.999.999 0 1 1 0 1.997m11.268.544h1.831l.347-.543h-2.137a.999.999 0 1 1-.001-1.997h1.74l.351-.545h-2.131a1.544 1.544 0 0 0-.08 3.086zm7.256-.544a1 1 0 0 1-.962-.727h2.536l.349-.544H20.9a1 1 0 0 1 .962-.727h1.741l.348-.545h-2.129a1.544 1.544 0 0 0 0 3.086h1.831l.347-.544h-2.14"
      />
    </g>
    <defs>
      <clipPath id="fi-brands-oracle_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiBrandsOracle;
